import { isValidId } from 'utils/predicates/fields.util';
import { isEqualByString } from 'utils/predicates/string/simple.util';

/** Hardcoded rule: only the logged-in staff member may set up or manage their own Stripe account. */
export const canManageOwnStaffStripe = (loggedInStylistId, targetStylistId) => {
  if (!isValidId(loggedInStylistId) || !isValidId(targetStylistId)) return false;
  return isEqualByString(loggedInStylistId, targetStylistId);
};
